import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Container, Box } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";

import routes from "./config/routes";
import { useGlobalState } from "./state";
import { supabase } from "./config/supabaseClient";
import AuthChecker from "./components/AuthChecker";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoadingSpinner from "./components/LoadingSpinner";
import Maintenance from "./components/Maintenance";

function App() {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENCE_KEY || "");
  const maintenanceMode = false;

  const [, setSession] = useGlobalState("session");
  const [, setUser] = useGlobalState("user");

  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) {
        setUser(session.user);
      }
      setIsLoading(false);
    });

    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session) {
        setUser(session.user);
      } else {
        setUser(null);
      }
    });
  }, [setSession, setUser]);

  if (maintenanceMode) {
    return <Maintenance />;
  }

  return (
    <HashRouter>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />
        <Container
          sx={{
            flexGrow: 1,
          }}
        >
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <Box mt={2} mb={2}>
              <React.Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  {routes.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      element={
                        route.protected ? (
                          <AuthChecker>
                            <route.component />
                          </AuthChecker>
                        ) : (
                          <route.component />
                        )
                      }
                    />
                  ))}
                </Routes>
              </React.Suspense>
            </Box>
          )}
        </Container>
        <Footer />
      </Box>
    </HashRouter>
  );
}

export default App;
